module.exports = __webpack_public_path__ + "img/C07TechHorsemanChampion_ua.ad3fa3be.webp";